
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-mnie",
      function () {
        return require("private-next-pages/o-mnie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/o-mnie"])
      });
    }
  